import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-flags-menu',
  templateUrl: './flags-menu.component.html',
  styleUrls: ['./flags-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlagsMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
